import { FC } from 'react';
import { Link as RouterLink } from 'react-router';
import {
  ListItem,
  ListItemText,
  Skeleton,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  Typography,
} from '@mui/material';

import { useRouter } from '@cvt/routing';

import { getMatchLabel } from '@shared/helpers/match';

import { UniversityOptions } from './UniversityOptions';

export const UniversityRow: FC<Universities.University> = university => {
  
  const router = useRouter();

  return (
    <ListItem
      disableGutters
      disablePadding
      divider
    >
      <ListItemButton
        alignItems="center"
        component={RouterLink}
        to={router.universities.view(university.id).path}
        sx={{
          opacity: university.match.isIgnored ? 0.5 : undefined,
          backgroundColor: university.match.isIgnored ? 'grey.200' : undefined,
          pr: 1,
        }}
      >
        <ListItemAvatar>
          <Avatar variant="rounded" src={university.logo} alt={university.name} />
        </ListItemAvatar>
        <ListItemText
          primary={(
            <Typography variant="body1" lineHeight={1} overflow="hidden" textOverflow="ellipsis" noWrap>
              <Typography fontSize={12} color="secondary">
                {university.sponsored ? 'Official Partner' : undefined}
              </Typography>
              {university.name}
            </Typography>
          )}
          secondary={getMatchLabel(university.match)}
          disableTypography
          slotProps={{
            root: {
              sx: {
                lineHeight: 1,
              },
            },
          }}
        />
        <UniversityOptions {...university} />
      </ListItemButton>
    </ListItem>
  );
};

export const UniversityRowSkeleton: React.FC = () => {

  return (
    <ListItem disableGutters disablePadding divider>
      <ListItemButton disabled>
        <ListItemAvatar>
          <Skeleton variant="rounded" width={40} height={40} />
        </ListItemAvatar>
        <ListItemText
          primary={<Skeleton width="60%" sx={{ maxWidth: 280 }} />}
          secondary={<Skeleton width="30%" />}
          slotProps={{
            root: {
              sx: {
                lineHeight: 1,
              },
            },
            primary: {
              lineHeight: 1,
            },
            secondary: {
              lineHeight: 1,
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
